/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/display-name */
import React, {
  Dispatch,
  ReactElement,
  SetStateAction,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react'

import {
  SendOutlined,
  UsergroupAddOutlined,
  CheckOutlined,
} from '@ant-design/icons'
import {
  Tabs,
  Descriptions,
  Skeleton,
  Table,
  Row,
  Col,
  Form,
  Input,
  Select,
  Button,
  Layout,
  Mentions,
  Dropdown,
  Menu,
  Comment,
  Tooltip,
  Spin,
  Badge,
} from 'antd'
import { RequiredMark } from 'antd/lib/form/Form'
import { SelectValue } from 'antd/lib/select'
import ID_COMPONENTE from 'config/idComponente'
import MACRO_CODIGO from 'config/macroCodigo'
import { ApplicationContext } from 'Context'
import { format } from 'date-fns'
import ILeitura from 'Models/chat/ILeitura'
import IMensagem from 'Models/chat/IMensagem'
import moment from 'moment'
import slugify from 'react-slugify'
import WS_CHAT from 'Services/WS_CHAT'
import WsDocasService from 'Services/WS_DOCAS'

import { ICandidato, IHorario, IMacro } from '../../../Models/docas'
import { STATUS_HORARIOS } from '../../../Models/docas/IHorario'
import IUsuario from '../../../Models/docas/Usuario'
import FormChecklist from '../Checklist/Form'
import { DocasContext } from '../Context/context'
import ChatDetalhes from '../Detalhes/ChatDetalhes'
import HorarioDetalhes from '../Detalhes/HorarioDetalhes'
import MacrosDetalhes from '../Detalhes/MacrosDetalhes'
import ModalAlertas from './ModalAlertas'

const { TabPane } = Tabs
const { TextArea } = Input
const { Footer, Content } = Layout
interface IProps {
  horario: IHorario
  startTab: number
  cdMacroTipo?: number
  setHorarioPrincipal: Dispatch<SetStateAction<IHorario | undefined>>
  atualizaAgenda: (
    limparSelecao?: boolean,
    executandoAcao?: boolean,
  ) => Promise<void>
}

const ModalDetalhes = ({
  horario,
  startTab,
  cdMacroTipo,
  setHorarioPrincipal,
  atualizaAgenda,
}: IProps): ReactElement => {
  const [horarioDetalhes, setHorarioDetalhes] = useState<IHorario | undefined>()
  const [, setCandidatoDetalhes] = useState<ICandidato | null>()
  const [loading, setLoading] = useState(false)
  const [activeTab, setActiveTab] = useState<string>(startTab.toString())
  const { docasContext, setDocasContext } = useContext(DocasContext)
  const [form] = Form.useForm()
  const [formChat] = Form.useForm()
  const [requiredMark, setRequiredMarkType] = useState<RequiredMark>('optional')
  const [usuariosSelected, setUsuariosSelected] = useState<string[]>()
  const [macros, setMacros] = useState<IMacro[]>([])

  useEffect(() => {
    const getDetalhes = async () => {
      setLoading(true)
      const { data } = await WsDocasService.agenda.getDetalhes(
        ID_COMPONENTE.DOCAS,
        horario.cdAgendamentoDocasHorario,
      )

      setHorarioDetalhes(data.data)

      const response = await WsDocasService.macro.getList(
        ID_COMPONENTE.DOCAS,
        docasContext.cdArmazemAtual,
      )

      if (response?.data?.items) {
        setMacros(response.data.items)
      }

      setLoading(false)
    }

    getDetalhes()
  }, [])

  useEffect(() => {
    if (horario.cdCandidatoAgendamento) {
      const getDetalhes = async () => {
        if (horarioDetalhes) {
          setLoading(true)

          const { data } = await WsDocasService.candidatos.getDetalhes(
            ID_COMPONENTE.DOCAS,
            horario.cdCandidatoAgendamento!,
          )
          if (data.items && data.items[0]) {
            setCandidatoDetalhes(data.items[0])
          }

          setHorarioPrincipal(horarioDetalhes)
          setLoading(false)
        }
      }

      getDetalhes()
    }
  }, [horarioDetalhes])

  const handleChangeTab = (key: string, e: any) => {
    setActiveTab(key)
  }

  return (
    <Tabs activeKey={activeTab} onTabClick={handleChangeTab} type="card">
      <TabPane tab="Detalhes" key="1">
        <Skeleton loading={loading} active>
          {horarioDetalhes && (
            <HorarioDetalhes horarioDetalhes={horarioDetalhes} />
          )}
        </Skeleton>
      </TabPane>
      <TabPane tab="Macros" key="2">
        {macros?.length > 0 ? (
          <MacrosDetalhes
            macros={macros}
            horario={horario}
            horarioDetalhes={horarioDetalhes}
            setHorarioDetalhes={setHorarioDetalhes}
            setLoading={setLoading}
            cdMacroTipo={cdMacroTipo}
            atualizaAgenda={atualizaAgenda}
          />
        ) : null}
      </TabPane>
      <TabPane tab="Chat" key="3">
        <ChatDetalhes
          horario={horario}
          usuariosSelected={usuariosSelected}
          setUsuariosSelected={setUsuariosSelected}
        />
      </TabPane>
      <TabPane tab="Alertas" key="4">
        <ModalAlertas horario={horario} />
      </TabPane>
      {/* <TabPane tab="Checklist" key="5">
        <Layout style={{ height: '100%' }}>
          <Content
            style={{
              height: '560px',
              overflowY: 'scroll',
              background: 'white',
            }}
          >
            <FormChecklist />
          </Content>
        </Layout>
      </TabPane> */}
    </Tabs>
  )
}

export default ModalDetalhes
